import React, { useEffect, useState, useCallback, useMemo } from "react";
import { gestorService } from "../services/apiService";

export const CreaDescarga = ({ pNif }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsuarioCategoria = useCallback(async () => {
    if (!pNif) {
      return; // No hacer nada si no hay NIF
    }

    setLoading(true);
    setError(null);

    try {
      const usuarioData = await gestorService.obtenerDatosUsuario(pNif);
      setUsuario(usuarioData);
    } catch (error) {
      console.error("Error al recuperar les dades de l'usuari:", error);
      setError(error.message || "Error al recuperar les dades de l'usuari");
    } finally {
      setLoading(false);
    }
  }, [pNif]);

  useEffect(() => {
    if (pNif) {
      fetchUsuarioCategoria();
    }
  }, [fetchUsuarioCategoria, pNif]);

  const getDescarga = useCallback(
    async (e, directorioDescarga, categoria, idCategoria) => {
      e.preventDefault();

      try {
        await gestorService.ejecutarDescargaCompleta(
          directorioDescarga,
          categoria,
          pNif,
          idCategoria
        );
      } catch (error) {
        console.error("Error a la descàrrega:", error);
        setError(error.message || "Error a la descàrrega");
      }
    },
    [pNif]
  );

  const usuarioList = useMemo(() => {
    if (!usuario || usuario.length === 0) return null;

    return usuario.map((usu) => (
      <form
        key={usu.idusercategoria}
        className="form-container-dw"
        onSubmit={(e) =>
          getDescarga(e, usu.directorioDescarga, usu.categoria, usu.idCategoria)
        }
        aria-label={`Formulari de descàrrega per a ${usu.descripcion}`}
      >
        <h2>{usu?.descripcion}</h2>
        <button
          className="btnfci"
          type="submit"
          disabled={loading}
          aria-label={`Descarregar fitxer ${usu.categoria}`}
        >
          {loading ? "DESCARRREGANT..." : "DESCARRREGAR"}
        </button>
      </form>
    ));
  }, [usuario, getDescarga, loading]);

  // Si no hay NIF, no mostrar nada
  if (!pNif) {
    return null;
  }

  if (loading) {
    return (
      <div
        className="loading-container"
        role="status"
        aria-label="Carregant dades"
      >
        <p>Carregant dades de l'usuari...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container" role="alert" aria-label="Error">
        <p className="pAvisoNoData">{error}</p>
        <button
          onClick={fetchUsuarioCategoria}
          className="retry-button"
          aria-label="Tornar a intentar càrrega de dades"
        >
          Tornar a intentar
        </button>
      </div>
    );
  }

  return (
    <>
      {usuarioList || (
        <p className="pAvisoNoData">
          En les properes hores es podran descarregar els PDFs de les fitxes.
          Disculpeu les molèsties.
        </p>
      )}
    </>
  );
};
